import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	model,
	OnInit,
	output,
	Signal,
	signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { InputComponent } from '@valk-nx/components/ui-input/src/lib/input';
import { cn } from '@valk-nx/core/lib/core';
import { GeneralHelper } from '@valk-nx/helpers/lib/general/general.helper';
import { ViewPortService } from '@valk-nx/services/viewport/src/lib/viewport.service';

import { AvailabilityWidgetInputComponent } from '../availability-input/availability-input';

import { AvailabilityInputDropdownItem } from './availability-input-dropdown.interface';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: `vp-availability-widget-input-dropdown`,
	templateUrl: './availability-input-dropdown.html',
	imports: [
		AngularSvgIconModule,
		AvailabilityWidgetInputComponent,
		InputComponent,
		TranslatePipe,
	],
})
export class AvailabilityWidgetInputDropdownComponent implements OnInit {
	private readonly viewport = inject(ViewPortService);

	className = input('');
	inputName = input.required<string>();
	items = input<AvailabilityInputDropdownItem[]>();
	label = input.required<string>();
	placeholder = input.required<string>();
	selectFirstItem = input<boolean>(false);
	searchable = input<boolean>(false);
	selectedItem = model<AvailabilityInputDropdownItem>();

	itemSelected = output<AvailabilityInputDropdownItem>();
	isSmallTablet: Signal<boolean>;
	emitBackButton = output<Event>();
	emitCta = output<Event>();

	isOpen = model<boolean>(false);

	searchTerm = signal<string>('');

	dropdownItems = computed<AvailabilityInputDropdownItem[]>(() => {
		if (!this.searchable() || !this.searchTerm()) return this.items();

		const searchTerm = GeneralHelper.getNormalizedName(this.searchTerm());

		return this.items().filter((item) =>
			GeneralHelper.getNormalizedName(item.name).includes(searchTerm),
		);
	});

	iconName = computed<string>(() => {
		if (this.items().length > 1) {
			return this.isOpen() ? 'icon-chevron-up' : 'icon-chevron-down';
		}
		return '';
	});

	cn = cn;

	constructor() {
		this.isSmallTablet = toSignal(this.viewport.isSmallTablet$);
	}

	ngOnInit(): void {
		if (
			!this.selectedItem() &&
			(this.items().length === 1 || this.selectFirstItem())
		) {
			this.onSelectItem(this.items()[0]);
		}
	}

	popoverStateChanged(isOpen: boolean) {
		this.isOpen.set(isOpen);
	}

	onSelectItem(item: AvailabilityInputDropdownItem) {
		this.selectedItem.set(item);
		this.itemSelected.emit(item);

		if (!this.isSmallTablet()) {
			this.popoverStateChanged(false);
		}
	}

	onEmitBackButton(event: Event) {
		this.popoverStateChanged(false);
		this.emitBackButton.emit(event);
	}

	onSearchInput(searchValue: string) {
		this.searchTerm.set(searchValue);
	}
}
